<dialog
  #dialog
  qai-dialog
  [description]="''"
  [heading]="'simulationBuilder.CREATE_NEW_ASSIGNMENT_BUTTON' | transloco"
  (closeButtonClicked)="handleCloseModal()"
>
  <assignment-information-view
    *ngIf="form"
    [form]="form"
    [assignmentTypeOptions]="assignmentTypeOptions"
    [isNewAssignment]="true"
  ></assignment-information-view>

  <div class="action-button-container">
    <button
      qai-button
      kind="secondary"
      [size]="'medium'"
      [disabled]="this.form?.valid ? this.networkRequestInProgress : true"
      (click)="handleSaveAndCloseClick()"
    >
      {{ 'simulationBuilder.BUTTON_SAVE_AND_CLOSE' | transloco }}
    </button>
    <button
      qai-button
      size="medium"
      kind="primary"
      [disabled]="this.form?.valid ? this.networkRequestInProgress : true"
      (click)="handleSuccessClick()"
    >
      {{ 'simulationBuilder.BUTTON_ADD_SIMULATIONS' | transloco }}
    </button>
  </div>
</dialog>
